import type { UserBike } from 'models/shared';

type FittingBike = {
  make: string | null;
  model: string | null;
  year: number | null;
};

export const getBikeFitment = (
  fitting_bikes: FittingBike[],
  userBikes: UserBike[],
  exact_only: boolean = false
): {
  multiple: boolean;
  bike: UserBike | null;
  status: 'may-fit' | 'fits' | 'does-not-fit';
} => {
  const exactMatches = userBikes.filter((bike) =>
    fitting_bikes.some(
      (fb) =>
        fb.make === bike.make &&
        fb.year === bike.year &&
        fb.model === bike.model
    )
  );

  if (!!exactMatches.length) {
    return {
      multiple: exactMatches.length > 1,
      bike: exactMatches[0],
      status: 'fits',
    };
  } else if (!exact_only) {
    // Check for fitting bikes that only have make (year and model are null)
    const makeOnlyFittingBikes = fitting_bikes.filter(
      (fb) => fb.make && !fb.year && !fb.model
    );

    const matchingBikes = userBikes.filter((bike) =>
      makeOnlyFittingBikes.some((fb) => fb.make === bike.make)
    );

    // Check if any user bike matches a make that matches one of the make only fitting bikes
    if (!!matchingBikes.length) {
      return {
        multiple: matchingBikes.length > 1,
        bike: matchingBikes[0],
        status: 'may-fit',
      };
    }

    const yearAndMakeOnlyFittingBikes = fitting_bikes.filter(
      (fb) => fb.year && fb.make && !fb.model
    );

    const matchingBikesYearMake = userBikes.filter((bike) =>
      yearAndMakeOnlyFittingBikes.some(
        (fb) =>
          fb.make === bike.make &&
          (fb.year === bike.year ||
            fb.year === bike.year! + 1 ||
            fb.year === bike.year! - 1)
      )
    );

    if (!!matchingBikesYearMake.length) {
      return {
        multiple: matchingBikesYearMake.length > 1,
        bike: matchingBikesYearMake[0],
        status: 'may-fit',
      };
    }

    // check if a user bike matches a year make model where the year is off by 1 up or down
    const fullBikes = userBikes.filter((bike) =>
      fitting_bikes.some(
        (fb) =>
          fb.make === bike.make &&
          (fb.year === bike.year ||
            fb.year === bike.year! + 1 ||
            fb.year === bike.year! - 1) &&
          fb.model === bike.model
      )
    );

    if (!!fullBikes.length) {
      return {
        multiple: fullBikes.length > 1,
        bike: fullBikes[0],
        status: 'may-fit',
      };
    }

    return {
      multiple: false,
      bike: null,
      status: 'does-not-fit',
    };
  } else {
    return {
      multiple: false,
      bike: null,
      status: 'does-not-fit',
    };
  }
};
